import { Checkbox, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ExpressFleetMallsConfig_malls_edges_node } from "@saleor/autobooking/types/ExpressFleetMallsConfig";
import React from "react";

import MallSearchInput from "../MallSearchInput";

const useStyles = makeStyles(
  () => ({
    checkBox: {
      "&.Mui-checked": {
        color: "#0030FF"
      },
      color: "#0030FF"
    },
    mallListContainer: {
      padding: "10px 5px",
      width: "100%"
    },
    mallListHeader: {
      alignItems: "center",
      borderBottom: "1px solid #CED3DD",
      display: "flex",
      justifyContent: "space-between",
      padding: "4px 10px"
    },
    mallListItem: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: "4px 10px"
    },
    mallListItems: {
      maxHeight: "300px",
      overflowY: "auto"
    },
    mallListItemsOdd: {
      backgroundColor: "#F4F8FF"
    },
    mallName: {
      fontSize: "16px"
    },
    mallNameClear: {
      padding: "0 5px 5px"
    },
    mallNameTitle: {
      fontSize: "16px",
      fontWeight: 600
    },
    searchContainer: {
      margin: "20px 0"
    }
  }),
  { name: "MallsListForm" }
);

export interface MallsListFormProps {
  malls: ExpressFleetMallsConfig_malls_edges_node[];
  selectedMalls?: any[];
  setSelectedMalls?: (string: any[]) => void;
  selectAll?: boolean;
  setSelectAll?: (val: boolean) => void;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  refetch: any;
}

const MallsListForm: React.FC<MallsListFormProps> = props => {
  const classes = useStyles(props);
  const {
    malls,
    selectedMalls,
    setSelectedMalls,
    selectAll,
    setSelectAll,
    searchText,
    setSearchText,
    refetch
  } = props;

  const onSearchText = (text: string) => {
    setSearchText(text);
    refetch();

    if (text === "") {
      setSelectAll(false);
    }
  };

  const handleCheckboxChange = (
    e: React.MouseEvent | React.ChangeEvent<HTMLInputElement>,
    mall: { id: string }
  ) => {
    e.stopPropagation();

    let isChecked: boolean;

    if ("checked" in e.target) {
      isChecked = (e.target as HTMLInputElement).checked;
    } else {
      isChecked = !selectedMalls.includes(mall.id);
    }

    const updated = isChecked
      ? [...selectedMalls, mall.id]
      : selectedMalls.filter(id => id !== mall.id);

    setSelectedMalls(updated);
    setSelectAll(updated.length === malls.length);
  };

  return (
    <div className={classes.mallListContainer}>
      <div className={classes.searchContainer}>
        <MallSearchInput
          key="autobookingMallsDialogSearch"
          initialSearch={searchText}
          placeholder="Search a Mall"
          onSearchChange={onSearchText}
        />
      </div>
      <div className={classes.mallListHeader}>
        <div className={classes.mallNameTitle}>
          Mall{" "}
          {selectedMalls.length > 0 ? (
            <>
              ({selectedMalls.length})
              <IconButton
                aria-label="close"
                onClick={() => {
                  setSelectedMalls([]);
                  setSelectAll(false);
                }}
                className={classes.mallNameClear}
              >
                <CloseIcon style={{ color: "#747C8C", fontSize: "18px" }} />
              </IconButton>
            </>
          ) : (
            <></>
          )}
        </div>
        <Checkbox
          id="autobookingMallsDialogSelectAllCheckbox"
          color="primary"
          className={classes.checkBox}
          checked={selectAll}
          onChange={e => {
            const isChecked = e.target.checked;
            setSelectAll(isChecked);
            if (isChecked) {
              setSelectedMalls(malls.map(mall => mall.id));
            } else {
              setSelectedMalls([]);
            }
          }}
        />
      </div>
      <div className={classes.mallListItems}>
        {malls.map((mall, index) => (
          <div
            key={mall.id}
            className={`${classes.mallListItem}
                        ${
                          (index + 1) % 2 === 0 ? "" : classes.mallListItemsOdd
                        }`}
            onClick={e => handleCheckboxChange(e, mall)}
          >
            <div className={classes.mallName}>{mall.name}</div>
            <Checkbox
              id={"autobookingMallsDialogCheckbox" + mall.id}
              color="primary"
              className={classes.checkBox}
              checked={selectedMalls?.includes(mall.id)}
              onClick={e => e.stopPropagation()}
              onChange={e => handleCheckboxChange(e, mall)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MallsListForm;
